import client from 'client'
import type {
  CreateManualIssueIssuePostMutationRequest,
  CreateManualIssueIssuePostMutationResponse,
  CreateManualIssueIssuePostQueryParams,
  CreateManualIssueIssuePost422,
} from '../../types/CreateManualIssueIssuePost.ts'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { RequestConfig, ResponseConfig, ResponseErrorConfig } from 'client'
import { useMutation } from '@tanstack/react-query'

export const createManualIssueIssuePostMutationKey = () => [{ url: '/issue' }] as const

export type CreateManualIssueIssuePostMutationKey = ReturnType<typeof createManualIssueIssuePostMutationKey>

/**
 * @summary Create Manual Issue
 * {@link /issue}
 */
export async function createManualIssueIssuePost(
  data: CreateManualIssueIssuePostMutationRequest,
  params?: CreateManualIssueIssuePostQueryParams,
  config: Partial<RequestConfig<CreateManualIssueIssuePostMutationRequest>> & { client?: typeof client } = {},
) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<
    CreateManualIssueIssuePostMutationResponse,
    ResponseErrorConfig<CreateManualIssueIssuePost422>,
    CreateManualIssueIssuePostMutationRequest
  >({ method: 'POST', url: `/issue`, params, data, ...requestConfig })
  return res
}

/**
 * @summary Create Manual Issue
 * {@link /issue}
 */
export function useCreateManualIssueIssuePost(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<CreateManualIssueIssuePostMutationResponse>,
      ResponseErrorConfig<CreateManualIssueIssuePost422>,
      { data: CreateManualIssueIssuePostMutationRequest; params?: CreateManualIssueIssuePostQueryParams }
    >
    client?: Partial<RequestConfig<CreateManualIssueIssuePostMutationRequest>> & { client?: typeof client }
  } = {},
) {
  const { mutation: mutationOptions, client: config = {} } = options ?? {}
  const mutationKey = mutationOptions?.mutationKey ?? createManualIssueIssuePostMutationKey()

  return useMutation<
    ResponseConfig<CreateManualIssueIssuePostMutationResponse>,
    ResponseErrorConfig<CreateManualIssueIssuePost422>,
    { data: CreateManualIssueIssuePostMutationRequest; params?: CreateManualIssueIssuePostQueryParams }
  >({
    mutationFn: async ({ data, params }) => {
      return createManualIssueIssuePost(data, params, config)
    },
    mutationKey,
    ...mutationOptions,
  })
}